import PopupLayout from "@/layouts/popup/popup-layout.vue";
import CdSelbx from "@/components/cd-selbx.vue";
import NumberIp from "@/components/number-ip.vue";
import Cal from "@/components/cal.vue";
import Mcal from "@/components/mcal.vue";
import Loading from '@/components/loading.vue';
import Alert from "@/components/alert.vue";
import Btn from "@/components/btn.vue"
import SingleFileUpload from "@/components/single-file-upload.vue";
import MultiFileUpload from "@/components/multi-file-upload.vue";
import Postcode from "@/components/postcode.vue";
import SignaturePad from "@/components/signature-pad.vue";
import Pagination from "@/components/pagination.vue";
import Editor from "@/components/editor.vue";
import SelfCrtfc from "@/components/self-crtfc.vue";

//component 등록시 pascal로 등록하면 pascal, kebab 둘다 사용가능
const customComponentPlugin = {
    install: (app) => {
        app.component('popup-layout', PopupLayout);
        app.component('cd-selbx', CdSelbx);
        app.component('number-ip', NumberIp);
        app.component('cal', Cal);
        app.component('mcal', Mcal);
        app.component('loading', Loading);
        app.component('alert', Alert);
        app.component('btn', Btn);
        app.component('single-file-upload', SingleFileUpload);
        app.component('multi-file-upload', MultiFileUpload);
        app.component('post-code', Postcode);
        app.component('sign-pad', SignaturePad);
        app.component('pagination', Pagination);
        app.component('editor', Editor);
        app.component('self-crtfc', SelfCrtfc);
    }
};

export {customComponentPlugin};
